// Get Refer Link
export const GET_REFERRALS_LINK_REQUEST = 'GET_REFERRALS_LINK_REQUEST';
export const GET_REFERRALS_LINK_DONE = 'GET_REFERRALS_LINK_DONE';
export const GET_REFERRALS_LINK_FAILED = 'GET_REFERRALS_LINK_FAILED';

// Create Refer Link
export const CREATE_REFERRALS_LINK_REQUEST = 'CREATE_REFERRALS_LINK_REQUEST';
export const CREATE_REFERRALS_LINK_DONE = 'CREATE_REFERRALS_LINK_DONE';
export const CREATE_REFERRALS_LINK_FAILED = 'CREATE_REFERRALS_LINK_FAILED';
export const CREATE_REFERRALS_LINK_RESET = 'CREATE_REFERRALS_LINK_RESET';
